import { HTMLAttributes } from 'react';
import { TLazyIconKey } from '../../../../utilities/iconLoader/FontAwesomeIcon';

export namespace HowOnlineRentalsWorkTypes {
  export interface IHowOnlineRentalsWork
    extends HTMLAttributes<HTMLDivElement> {
    sectionTitle: TTextConfig;
    steps: IStep[];
    showSection: boolean;
    isVertical?: boolean;
    backgroundColor?: TColorType;
    fontColors?: TFontColorConfig;
  }

  export interface IStep extends HTMLAttributes<HTMLDivElement> {
    icon: TIconConfig;
    title: string;
    description: string; // html
    isVertical?: boolean;
    isFirst?: boolean;
    isLast?: boolean;
    fontColors?: TFontColorConfig;
  }

  export type TIconConfig = {
    iconName: TLazyIconKey;
    color: TColorType;
    size?: number;
  };

  export type TTextConfig = {
    text: string;
    fontColor?: TColorType;
  };

  export type TFontColorConfig = {
    title: TColorType;
    description: TColorType;
  };

  export type TColorType = 'primary' | 'secondary' | 'accent' | string;
}
